import axios from 'axios'
import { getLocalStorage } from './LocalStorage'
import helper from './Variables'

const getHeaders = () => ({
  Authorization:
    getLocalStorage(helper.TOKEN_KEY) !== null
      ? `Bearer ${getLocalStorage(helper.TOKEN_KEY)}`
      : null,
  'Content-Type': 'application/json'
})

export const post = async (url = '', data = {}) => {
  console.log('body', data)
  const response = await fetch(url, {
    method: 'POST',
    cache: 'no-cache',
    credentials: 'omit',
    headers: getHeaders(),
    redirect: 'follow',
    body: JSON.stringify(data),
    mode: 'cors'
  })

  console.log('postResponse', response)
  return response.json()
}

export const get = async url => {
  const response = await fetch(url, {
    method: 'GET',
    cache: 'no-cache',
    credentials: 'omit',
    headers: getHeaders(),
    redirect: 'follow',
    mode: 'cors'
  })
  return response.json()
}
export const customGet = async url => {
  try {
    const response = await axios.get(url, {
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Headers': 'Content-Type'
      }
    })
    return response
  } catch (error) {
    return error
  }
}

export const getS3 = async url => {
  const response = await fetch(url, {
    method: 'GET',
    cache: 'no-cache',
    credentials: 'omit',
    redirect: 'follow',
    mode: 'cors'
  })
  return response.text()
}
